import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
export function Hero() {
  const bullets: React.ReactNode[] = [<>
      Sentite{' '}
      <strong className="font-bold text-deep-black" data-id="element-175">
        deseada, confiada y en control
      </strong>
    </>, <>
      Rompé el bucle de perseguir{' '}
      <em className="not-italic underline decoration-bordeaux/40 decoration-2 underline-offset-2" data-id="element-176">
        migajas
      </em>{' '}
      y{' '}
      <strong className="font-bold text-deep-black" data-id="element-177">
        hombres sin compromiso
      </strong>
    </>, <>
      Aprendé exactamente lo que hace que los hombres se interesen de verdad y{' '}
      <strong className="font-bold text-deep-black" data-id="element-178">se obsesionen</strong>
    </>, <>
      <strong className="font-bold text-deep-black" data-id="element-179">Acceso instantáneo</strong>{' '}
      + Meditación + Manual de Ejercicios incluido
    </>];
  return <section className="relative bg-white pb-14 overflow-hidden" data-id="element-180">
      {/* Hero image — full-bleed on mobile, constrained on desktop */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8
    }} className="relative w-full lg:max-w-5xl lg:mx-auto lg:px-6 lg:pt-6" data-id="element-181">
        <img src="https://cdn.magicpatterns.com/uploads/7uPbq88xyW5nXQHx724PFC/ChatGPT_Image_11_may_2026,_02_13_03_a.m..png" alt="Pack Diosa Letal: libro, cuaderno de ejercicios y meditación guiada" className="w-full h-auto object-cover shadow-2xl lg:rounded-sm" data-id="element-182" />
      </motion.div>

      {/* Text content below */}
      <div className="max-w-3xl mx-auto px-6 lg:px-8 pt-[10px]" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-center" data-id="element-184">
          <div className="mb-6" data-id="element-185">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-playfair text-deep-black leading-[1.1] mb-4" data-id="element-186">
              Conviértete en la Mujer que{' '}
              <span className="italic text-bordeaux" data-id="element-187">
                él no puede dejar de pensar
              </span>
            </h1>
            <h2 className="text-2xl sm:text-3xl font-cormorant italic text-bordeaux mb-6" data-id="element-188">
              "Desata a tu Diosa Letal Interior"
            </h2>
          </div>

          <p className="text-lg text-gray-700 font-inter mb-6 leading-relaxed" data-id="element-189">
            La guía para{' '}
            <strong className="font-bold text-deep-black" data-id="element-190">
              dejar de sobrepensar
            </strong>
            , reclamar tu poder y hacer que los hombres{' '}
            <span className="bg-gold/25 px-1 rounded-sm font-semibold text-deep-black" data-id="element-191">
              te persigan, respeten y se obsesionen
            </span>{' '}
            por vos.
          </p>

          <ul className="space-y-3 mb-8 text-left max-w-xl mx-auto" data-id="element-192">
            {bullets.map((bullet, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3 + idx * 0.1
          }} className="flex items-start" data-id="element-193">
                <Check className="w-6 h-6 text-bordeaux mr-3 flex-shrink-0 mt-0.5" data-id="element-194" />
                <span className="text-gray-800 font-inter font-medium" data-id="element-195">
                  {bullet}
                </span>
              </motion.li>)}
          </ul>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-196">
            <CTAButton scrollTo="oferta-final" className="w-full sm:w-auto text-sm sm:text-base" data-id="element-197">
              Descargar Ahora
            </CTAButton>
          </div>

          <div className="mt-6 flex items-center justify-center space-x-2 text-sm text-gray-500 font-inter" data-id="element-198">
            <div className="flex -space-x-1" data-id="element-199">
              {[...Array(5)].map((_, i) => <div key={i} className="w-6 h-6 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center overflow-hidden" data-id="element-200">
                  <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover" data-id="element-201" />
                </div>)}
            </div>
            <span data-id="element-202">
              Más de <strong data-id="element-203">2.300 argentinas</strong> ya activaron su Diosa
              Letal · Garantía de 30 días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}